// import React from "react";
// import "./NurseCareer.css";

// const NurseUsaCareer = () => {
//   return (
//     <div className="nurse-career-container">
//       <h1>Nurse Career in USA</h1>
//       <p>
//         A nursing career in the USA offers good job prospects, competitive
//         salaries, and diverse opportunities. To become a nurse, you’ll need to
//         obtain a nursing degree, pass the NCLEX-RN exam, and secure a nursing
//         license. English language proficiency is also required, often
//         demonstrated through exams like IELTS or TOEFL.
//       </p>

//       <h2>Job Market</h2>
//       <p>
//         The demand for nurses in the US is projected to grow, with the Bureau of
//         Labor Statistics forecasting a 6% increase in employment for registered
//         nurses from 2022 to 2032, according to the Bureau of Labor Statistics.
//       </p>

//       <h2>Education</h2>
//       <p>
//         A Bachelor of Science in Nursing (BSN) is becoming the preferred
//         entry-level degree for many employers, though an Associate’s Degree in
//         Nursing (ADN) is also a valid path.
//       </p>

//       <h2>Licensure</h2>
//       <p>
//         The National Council Licensure Examination (NCLEX-RN) is a crucial step
//         for becoming a registered nurse in the US.
//       </p>

//       {/* Image Placeholder */}
//       <div className="nurse-image">
//         <img
//           src="your-usa-image.jpg"
//           alt="Nurse Career in USA"
//         />
//       </div>

//       {/* Inquiry Form */}
//       <div className="inquiry-form">
//         <h2>Inquiry Form</h2>
//         <form>
//           <label>Name:</label>
//           <input type="text" name="name" placeholder="Enter your name" />

//           <label>Email:</label>
//           <input type="email" name="email" placeholder="Enter your email" />

//           <label>Message:</label>
//           <textarea name="message" placeholder="Enter your message"></textarea>

//           <button type="submit">Submit</button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default NurseUsaCareer;

import React, { useEffect, useState } from "react";

const NurseUsaCareer = () => {
  const [isMobile, setIsMobile] = useState(() => (typeof window !== "undefined" ? window.innerWidth <= 768 : false));

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={{ fontFamily: "'Segoe UI', Arial, sans-serif", maxWidth: "1100px", margin: "0 auto", padding: isMobile ? "20px 14px" : "30px 20px" }}>
      
      {/* Top Two-Column: Image Left, Content Right */}
      <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", gap: isMobile ? "16px" : "30px", alignItems: "flex-start", marginBottom: isMobile ? "24px" : "40px" }}>
        
        {/* Left - Image */}
        <div style={{ flex: isMobile ? "0 0 auto" : "0 0 400px", width: isMobile ? "100%" : "400px" }}>
          <img
            src="https://images.unsplash.com/photo-1584820927498-cfe5211fd8bf?w=600"
            alt="Nurse Career in USA"
            style={{ width: "100%", height: isMobile ? "220px" : "320px", objectFit: "cover", borderRadius: "10px", display: "block" }}
          />
        </div>

        {/* Right - Main Intro Content */}
        <div style={{ flex: 1, width: "100%" }}>
          <h1 style={{ fontSize: "28px", color: "#1a3c5e", marginBottom: "15px" }}>Nurse Career in USA</h1>
          <p style={{ fontSize: "15px", lineHeight: "1.7", color: "#444", marginBottom: "20px" }}>
            A nursing career in the USA offers good job prospects, competitive salaries, and diverse opportunities.
            To become a nurse, you'll need to obtain a nursing degree, pass the NCLEX-RN exam, and secure a nursing
            license. English language proficiency is also required, often demonstrated through exams like IELTS or TOEFL.
          </p>

          <h2 style={{ fontSize: "18px", color: "#1a3c5e", marginBottom: "8px" }}>Job Market</h2>
          <p style={{ fontSize: "15px", lineHeight: "1.7", color: "#444", marginBottom: "16px" }}>
            The demand for nurses in the US is projected to grow, with the Bureau of Labor Statistics forecasting
            a 6% increase in employment for registered nurses from 2022 to 2032.
          </p>

          <h2 style={{ fontSize: "18px", color: "#1a3c5e", marginBottom: "8px" }}>Education</h2>
          <p style={{ fontSize: "15px", lineHeight: "1.7", color: "#444", marginBottom: "16px" }}>
            A Bachelor of Science in Nursing (BSN) is becoming the preferred entry-level degree for many employers,
            though an Associate's Degree in Nursing (ADN) is also a valid path.
          </p>

          <h2 style={{ fontSize: "18px", color: "#1a3c5e", marginBottom: "8px" }}>Licensure</h2>
          <p style={{ fontSize: "15px", lineHeight: "1.7", color: "#444" }}>
            The National Council Licensure Examination (NCLEX-RN) is a crucial step for becoming a registered nurse in the US.
          </p>
        </div>
      </div>

      {/* Inquiry Form */}
      <div style={{ background: "#f5f8fc", borderRadius: "10px", padding: isMobile ? "20px 16px" : "30px", marginTop: "20px" }}>
        <h2 style={{ fontSize: "22px", color: "#1a3c5e", marginBottom: "20px" }}>Inquiry Form</h2>
        <div style={{ display: "flex", flexDirection: "column", gap: "15px", maxWidth: "600px" }}>
          <div>
            <label style={{ fontSize: "14px", fontWeight: "600", color: "#333", display: "block", marginBottom: "5px" }}>Name:</label>
            <input type="text" placeholder="Enter your name"
              style={{ width: "100%", padding: "10px 14px", fontSize: "15px", border: "1px solid #ccc", borderRadius: "6px", outline: "none" }} />
          </div>
          <div>
            <label style={{ fontSize: "14px", fontWeight: "600", color: "#333", display: "block", marginBottom: "5px" }}>Email:</label>
            <input type="email" placeholder="Enter your email"
              style={{ width: "100%", padding: "10px 14px", fontSize: "15px", border: "1px solid #ccc", borderRadius: "6px", outline: "none" }} />
          </div>
          <div>
            <label style={{ fontSize: "14px", fontWeight: "600", color: "#333", display: "block", marginBottom: "5px" }}>Message:</label>
            <textarea placeholder="Enter your message" rows={4}
              style={{ width: "100%", padding: "10px 14px", fontSize: "15px", border: "1px solid #ccc", borderRadius: "6px", outline: "none", resize: "vertical" }} />
          </div>
          <button type="button"
            style={{ width: isMobile ? "100%" : "160px", padding: "11px", background: "#1a3c5e", color: "#fff", fontSize: "15px", fontWeight: "600", border: "none", borderRadius: "6px", cursor: "pointer" }}>
            Submit
          </button>
        </div>
      </div>
          <div className="back-home-wrapper">
  <button className="back-home-btn" onClick={() => window.location.href = "/"}>
    ← Go Back to Home
  </button>
</div>
    </div>
  );
};

export default NurseUsaCareer;